import TextInput from "../TextInput";

const PasswordInput = (props) => {
	return <TextInput type="password" enablePasswordToggle {...props} />;
};

export default PasswordInput;
